import { render, staticRenderFns } from "./flowfact.vue?vue&type=template&id=62923900&"
import script from "./flowfact.vue?vue&type=script&lang=js&"
export * from "./flowfact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports